import React from 'react';

import { Box, Flex, Select, Text } from 'core/components';

type LookbackSelectOption = {
  label: string;
  value: string;
};
type PlanCardVizHeaderProps = {
  leftText: string;
  lookback: LookbackSelectOption;
  handleTimePeriodChange: (value: string) => void;
  showSelect?: boolean;
  timePeriodOptions: LookbackSelectOption[];
  externalLinkElement?: React.ReactNode;
};

const PlanCardVizHeader = ({
  leftText,
  lookback,
  handleTimePeriodChange,
  showSelect,
  timePeriodOptions,
  externalLinkElement
}: PlanCardVizHeaderProps) => (
  <Flex justifyContent="space-between" alignItems="center" my={1}>
    <Text fontSize={14} color="muted">
      {leftText}
    </Text>

    <Flex alignItems="center">
      {showSelect && (
        <Box mr={2}>
          <Select
            options={timePeriodOptions}
            values={lookback.value}
            onChange={handleTimePeriodChange}
            placeholder="Select time period"
            width={100}
          />
        </Box>
      )}

      {externalLinkElement}
    </Flex>
  </Flex>
);

export default PlanCardVizHeader;
